import 'reset-css/reset.css';
import Vue from 'vue';
import VipSixUi from 'vip-six-ui';
import VueRouter from 'vue-router';

// 新PV
import '@badger/tracker';

// 需要的话路径自行修改
// import util from '../../lib/util';
import tracker from '../../lib/tracker';

import './index.less';
import Index from './index.vue';
import 'vip-six-ui/lib/theme-chalk/index.css';
import '@badger/badge/lib/index.css';
import '@badger/signup/lib/index.css';

const router = new VueRouter({
  mode: 'history',
  base: 'tp-m/share-me.html',
  routes: [{
    name: 'index',
    path: '',
    component: Index
  }]
});
Vue.use(VipSixUi);
Vue.config.productionTip = false;
window.tracker = tracker;
Vue.use(VueRouter);
new Vue({
  router,
}).$mount('#app');
